import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  grid: {
    display: 'flex',
    alignItems: 'stretch'
  }
}));
